export default {
  GeneralError: {
    Title:
      'Похоже, что-то пошло не так — может попробуем ещё раз?',
    Button: {
      Return: 'Вернуться на предыдущую страницу',
      Contact: 'Связаться с нами',
    },
    Or: 'или',
  },
  CantInsure: {
    Title:
      'Мы не можем предложить вам онлайн-оферту',
    HelpText:
      'Свяжитесь с нашим консультантом, чтобы узнать, как мы можем вам помочь. Позвоните по номеру 22 501 35 01.',
  },
  NotFoundError: {
    Title: 'Упс, страница не найдена',
    Text: 'Сейчас вы будете перенаправлены на рабочую страницу:',
  },
};
